(function($){
$(document).ready(function() {

    $('.les-focus').slick({
        autoplay: true,
        autoplaySpeed: 6000,
        pauseOnHover: false,
        pauseOnFocus: true,
        pauseOnDotsHover: true,
        focusOnSelect: true,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 2000,
        fade: true,
        cssEase: 'ease-in-out',
    })
    .on('setPosition', function(event, slick){
        slideTimer.addClass('start');
    })
    .on('beforeChange', function(event, slick, currentSlide, nextSlide){
        slideTimer.addClass('fading');
    })
    .on('afterChange', function(event, slick, currentSlide, nextSlide){
        slideTimer.removeClass('fading start');
    });
    let slideTimer=$('<div class="slide-timer"></div>');
    slideTimer.appendTo($('.les-focus'));

    $('.scroll-down').on('click', function(){
        let offset = $('.site-header').outerHeight();
        offset = -1 * (offset + 20);
        if($('html').hasClass('no-csspositionsticky')) {
          offset = -220;
          if($('.site-header').hasClass('js-is-sticky'))
            offset += 100;
        }
        console.log("offset", offset);
        $(window).scrollTo($('.page-title'), 600, {
            offset: offset,
            axis:'y'
        });

    })
}); // document.ready
})(jQuery);
